export default __webpack_public_path__ + "static/en-132ae7f57ff72490af564b3905fd7cfe.svg";